/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useMemo, useState, useEffect } from "react";
import { useDracoGLTF } from "../../../utils/useDracoGLTF";
import { config as springConfig, useTransition } from "@react-spring/three";
import FactsAndFiguresMarker from "../factsandfigures/FactsAndFiguresMarker";

export function RenewableEnergy({ ...props }) {
  const { nodes } = useDracoGLTF("./models/heat/RenewableEnergy.glb");
  const [hardeningState, setHardeningState] = useState([]);
  const [brazingState, setBrazingState] = useState([]);

  const hardeningPositions = useMemo(() => {
    var positions = [];
    nodes["hardening"].children.forEach((c) => {
      positions.push(c.position);
    });
    return positions;
  }, [nodes]);

  const brazingPositions = useMemo(() => {
    var positions = [];
    nodes["brazing"].children.forEach((c) => {
      positions.push(c.position);
    });
    return positions;
  }, [nodes]);

  const hardeningTransition = useTransition(hardeningState, {
    from: { scale: 0 },
    enter: { scale: 1 },
    leave: { scale: 0 },
    trail: 150,
    config: springConfig.default,
  });

  const brazingTransition = useTransition(brazingState, {
    from: { scale: 0 },
    enter: { scale: 1 },
    leave: { scale: 0 },
    trail: 150,
    config: springConfig.default,
  });

  const hardening = hardeningTransition((style, item, t, i) => {
    return (
      <FactsAndFiguresMarker
        style={style}
        position={item}
        id={`Hardening_${i}`}
        key={`Hardening_${i}`}
        color="#ee8a81"
        circleSegments={16}
        size={0.03}
        lineHeight={1}
      />
    );
  });

  const brazing = brazingTransition((style, item, t, i) => {
    return (
      <FactsAndFiguresMarker
        style={style}
        position={item}
        id={`Brazing_${i}`}
        key={`Brazing_${i}`}
        color="#f5d07a"
        circleSegments={16}
        size={0.03}
        lineHeight={1}
      />
    );
  });

  useEffect(() => {
    setHardeningState(hardeningPositions);
    setBrazingState(brazingPositions);
  }, []);

  return (
    <group {...props} dispose={null}>
      <group position={[11.91, 0, 4.83]}>
        {hardening}
        {brazing}
      </group>
    </group>
  );
}

useDracoGLTF.preload("./models/heat/RenewableEnergy.glb");
